/**
 * Cart Compatible Products component
 *
 * @module cart-compatible-products
 * @version 1.0.0
 * @extends HTMLElement
 **/

customElements.component = 'cart-compatible-products';

if (!customElements.get(customElements.component)) {

	class cartCompatibleProducts extends HTMLElement {
		constructor() {
			super();

			this.handle = this.dataset.handle;
			this.productID = parseInt(this.dataset.productId);
			this.variantID = parseInt(this.dataset.variantId);
			this.itemKey = this.dataset.itemKey;

			// Elements
			this.viewMoreProductsButton = this.querySelector('.view-more-products');

			// Set Elements and Data
			window.theme.product
				.loadProduct(this.dataset.handle, true)
				.then((product) => {
					this.modalViewMoreProducts = document.querySelector(`modal-view-more-products[data-item-key="${this.itemKey}"]`);

					this.product = product;
					this.render(product);
				});
		}

		initEvents() {
			if (!this.viewMoreProductsButton) return;

			this.viewMoreProductsButton.addEventListener('click', () => {
				//console.log('this.product:', this.product);

				if (this.modalViewMoreProducts) {
					this.modalViewMoreProducts.show();
				}
			});
		}

		render(product) {
			this.initEvents();

			this.dataset.ready = "true";
		}
	}

	customElements.define(customElements.component, cartCompatibleProducts);
}

